import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import ResponsiveImage from "../responsive-image/ResponsiveImage";
//limitless imports
import { limitlessImage } from "@limitless/images";
const useStyles = makeStyles(theme => ({
  container: {
    position: "relative",
    top: 13
  },
  imageContainer: {
    marginLeft: "auto",
    marginBottom: 30
  },
  imageContent: {
    width: "100%",
    height: "100%",
    borderRadius: 16,
    maxHeight: 504
  },
  contentContainer: {
    marginTop: "6%",
    position: "absolute",
    backgroundColor: "#e8e8e8",
    borderRadius: 12,
    padding: "2% 2% 2% 6%",
    wordWrap: "break-word"
  },
  mobileSubHeader: {
    display: "block",
    textAlign: "center"
  },
  subHeader: {
    display: "none"
  },
  [theme.breakpoints.up("sm")]: {
    contentContainer: {
      marginTop: "5%",
      padding: "3% 3% 2% 4%"
    },
    mobileSubHeader: {
      display: "none"
    },
    subHeader: {
      display: "block"
    },
    container: {
      top: 33
    },
    imageContainer: {
      marginBottom: 95
    }
  },
  [theme.breakpoints.up("md")]: {
    container: {
      top: 53
    },
    imageContainer: {
      marginBottom: 60
    }
  },
  [theme.breakpoints.up("lg")]: {
    contentContainer: {
      marginTop: "8%",
      paddingLeft: "7%",
      left: -20
    }
  }
}));
const OldSignUpWelcome = ({
  content
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.container
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: classes.imageContainer,
    xs: 7
  }, /*#__PURE__*/React.createElement(ResponsiveImage, {
    images: content.images,
    imageAlt: "sign-up-welcome",
    imageStyles: classes.imageContent,
    noImageSrc: limitlessImage
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    lg: 6,
    className: classes.contentContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    gutterBottom: true
  }, content.header), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    gutterBottom: true,
    className: classes.subHeader
  }, content.subHeader)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    gutterBottom: true,
    className: classes.mobileSubHeader
  }, content.subHeader));
};
OldSignUpWelcome.propTypes = {
  content: PropTypes.object.isRequired
};
export default OldSignUpWelcome;